import React from "react";
import Nicholas from "assets/Nicholas.png";

// form & validsation
import * as yup from "yup";
import {
  FormLabel,
  FormInput,
  FormRadio,
  FormError,
  FormDropDown,
  FormTextArea,
} from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";

// schema
const Step18schema = yup
  .object()
  .shape({
    past_steps: yup
      .object()
      .shape({
        past_discussions_assets: yup
          .string()
          .required("This is a required field"),
        past_discussions_children: yup
          .string()
          .required("This is a required field"),
        if_court_assets: yup.string().required("This is a required field"),
        // court_assets_summary: yup.string().required("This is a required field"),
        if_court_children: yup.string().required("This is a required field"),
        // court_children_summary: yup
        //   .string()
        //   .required("This is a required field"),
      })
      .required(),
  })
  .required();

export function Step18({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(Step18schema),
  });

  const handleData = (values) => {
    const copy_data = Object.assign({}, store.past_steps);
    const merger_current_values = { ...copy_data, ...values.past_steps };
    const mergeToStore = { ...store, past_steps: merger_current_values };
    onSubmit(mergeToStore);
  };
  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`past_steps.past_discussions_assets`}
            className={customClasses.questionText}
            error={errors?.past_steps?.past_discussions_assets?.message}
          >
            What discussions have you both had about dividing your assets?
          </FormLabel>
          <article>
            <FormDropDown
              placeholder="Make a selection"
              id={`past_steps.past_discussions_assets`}
              type="text"
              name={`past_steps.past_discussions_assets`}
              error={errors?.past_steps?.past_discussions_assets?.message}
              setValue={setValue}
              data={[
                `None`,
                `We had some but not a lot`,
                `We're a close to getting an arrangement`,
                `Informal agreement in place`,
                `We’ve formalised it (e.g consent orders, court orders or binding financial agreement)`,
              ]}
              register={register}
              value={watch()?.past_steps.past_discussions_assets}
            />
          </article>
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`past_steps.past_discussions_children`}
            className={customClasses.questionText}
            error={errors?.past_steps?.past_discussions_children?.message}
          >
            What discussions have you both had about how to care for your
            children?
          </FormLabel>
          <article>
            <FormDropDown
              placeholder="Make a selection"
              id={`past_steps.past_discussions_children`}
              type="text"
              name={`past_steps.past_discussions_children`}
              error={errors?.past_steps?.past_discussions_children?.message}
              data={[
                `None`,
                `We had some but not a lot`,
                `We're a close to getting an agreement`,
                `Informal agreement in place`,
                `We’ve formalised it (e.g consent orders, court orders or binding financial agreement)`,
              ]}
              setValue={setValue}
              register={register}
              value={watch()?.past_steps.past_discussions_children}
            />
          </article>
        </section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`past_steps.if_court_assets`}
            className={customClasses.questionText}
            error={errors?.past_steps?.if_court_assets?.message}
          >
            Has there been any court proceedings regarding the assets of
            relationship?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="past_steps.if_court_assets"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="past_steps.if_court_assets"
              register={register}
            />
          </article>
          <FormError error={errors?.past_steps?.if_court_assets?.message} />
        </section>

        {/* <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`past_steps.court_assets_summary`}
            className={customClasses.questionText}
            error={errors?.past_steps?.court_assets_summary?.message}
          >
            Please provide a short summary
          </FormLabel>
          <article>
            <FormTextArea
              placeholder="Type here"
              id={`past_steps.court_assets_summary`}
              type="text"
              name={`past_steps.court_assets_summary`}
              error={errors?.past_steps?.court_assets_summary?.message}
              register={register}
            />
          </article>
          <FormError
            error={errors?.past_steps?.court_assets_summary?.message}
          />
        </section> */}

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`past_steps.if_court_children`}
            className={customClasses.questionText}
            error={errors?.past_steps?.if_court_children?.message}
          >
            Has there been any court proceedings regarding the children?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="past_steps.if_court_children"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="past_steps.if_court_children"
              register={register}
            />
          </article>
          <FormError error={errors?.past_steps?.if_court_children?.message} />
        </section>

        {/* <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor={`past_steps.court_children_summary`}
            className={customClasses.questionText}
            error={
              errors?.past_steps?.court_children_summary?.ownership?.message
            }
          >
            Please provide a short summary
          </FormLabel>
          <article>
            <FormTextArea
              placeholder="Type here"
              id={`past_steps.court_children_summary`}
              type="text"
              name={`past_steps.court_children_summary`}
              error={
                errors?.past_steps?.court_children_summary?.ownership?.message
              }
              register={register}
            />
          </article>
          <FormError error={errors?.ex_if_cooperation?.message} />
        </section> */}
      </section>
    </form>
  );
}
